export const api1 = "https://secure-basin-28765.herokuapp.com"
export const api2 = "https://fathomless-brook-87233.herokuapp.com/"


